import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const CoordinationInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Coordinación o departamento">
      {getFieldDecorator("coordination", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa la coordinación o departamento."
          }
        ],
        initialValue: implementerProfile && implementerProfile.coordination
      })(
        <Input
          disabled={isBusy}
          id="coordination"
          name="coordination"
          placeholder="Coordinación o departamento"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
